<template>
    <div    class="flex flex-col">
        <div    v-if="handlerSettings"
                class="mb-2">
            <select2    :options="handlers"
                        name="alarm_handler"
                        placeholder="Select Alarm Handler"
                        v-model:value="handlerSettings['handler']"
                        :close-on-select="true"
            ></select2>
        </div>

        <!-- Berkshire Pressure With Closed-Contact sensor -->
        <div    v-if="modelValue">
            <div    v-if="modelValue.handler === 'Door-Status Dependent Pressure Alarms'">
                <alarm-handler-pressure-with-door-status   v-model="handlerSettings"
                ></alarm-handler-pressure-with-door-status>
            </div>

            <!-- Default Alarm Handler -->
            <div    v-else>
            </div>
        </div>
    </div>
</template>

<script>
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import Select2 from "@/components/elements/select2";
import AlarmHandlerPressureWithDoorStatus from "@/components/alarmProfiles/AlarmHandlerPressureWithDoorStatus";

export default {
    name: "AlarmHandlerSelect",
    mixins: [SonicuCoreMixin, iconNamesMixin],
    components: {AlarmHandlerPressureWithDoorStatus, Select2},
    compatConfig: { COMPONENT_V_MODEL: false },
    emits: ['update:modelValue'],
    props: {
        modelValue: Object,
        handlers: Object,
    },
    data() {
        return {
            handlerSettings: this.modelValue,
        }
    },
    created() {
    },
    mounted() {
        this.updateAlarmHandler()
    },
    methods: {
        updateAlarmHandler(tmp) {
            if (!tmp) {
                tmp = this.handlerSettings
            }

            this.$emit('update:alarmHandler', tmp)
        },
    },
    computed: {
        
    },
    watch: {
        handlerSettings(val, old) {
            if (val === this.modelValue) {
                return
            }

            this.updateAlarmHandler()
        },
        alarmHandler(val, old) {
            if (val === this.handlerSettings) {
                return
            }

            this.handlerSettings = val
        },
    },
}
</script>

<style scoped>

</style>